var map = {
	"./Binary_search_in_a_game.png": 2882,
	"./altaviz-support-ltd.png": 2027,
	"./altaviz_mobile.png": 9369,
	"./article-hive-app.png": 2088,
	"./article-hive-app1.png": 7683,
	"./article-hive.png": 3154,
	"./classic-brownline.png": 1210,
	"./creonovo-gardens.png": 1473,
	"./creonovo-website.png": 3228,
	"./creonovo_restaurant-backend-component.png": 5557,
	"./creonovo_restaurant.png": 9692,
	"./custom_commands2.png": 5819,
	"./dafetite-ogaga.png": 2837,
	"./dsa-linkedlist.png": 6381,
	"./eStudieBuddie.png": 9803,
	"./famouspropertiesng.png": 8658,
	"./jimmy_ayodele.png": 1341,
	"./little-lemon-capstone-project-figma-design.png": 4313,
	"./little-lemon-figma-designs.png": 8556,
	"./pdf2docx Converter.png": 9101,
	"./studdiebudie.png": 7180,
	"./techflows.png": 3872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4004;